import React, {useEffect} from "react"
import {Route, Switch} from "react-router-dom";
import {AuthPage} from "./pages/AuthPage/AuthPage";
import {GeneralOfferPage} from "./pages/generalOfferFields/GeneralOfferPage";
import {OrdersSyncPage} from "./pages/ordersSync/OrdersSync";
import {StockUpdatePage} from "./pages/stocksUpdate/StockUpdatePage";
import {PriceUpdatePage} from "./pages/priceUpdate/PriceUpdatePage";
import {SelectProductsPage} from "./pages/selectProductsPage/SelectProductsPage";
import {CategoriesComparePage} from "./pages/categoryComparePage/CategoriesComparePage";
import {AttributesCategoryComparePage} from "./pages/offerAttributes/AttributesCategoryComparePage";
import {ExportPage} from "./pages/ExportPage";
import {ExportHistoryPage} from "./pages/exportHistory/ExportHistoryPage";
import {StocksHistoryPage} from "./pages/stocksUpdate/StocksHistoryPage";
import {ProductPage} from "./pages/ProductsPage";
import {OrdersDebugPage} from "./pages/ordersDebug/OrdersDebugPage";
import {Menu} from "./components/Menu";
import {Notices} from "./components/Notices";
import ExportProductsApi from "./api/ExportProductsApi"

export const appPages = {
    apiSettings: "/",
    selectProducts: '/select-products',
    categoriesComparison: '/categories-comparison',
    generalOfferAttributes: '/general-offer-attributes',
    offerAttributes: '/offer-attributes',
    offersExport: '/offers-export',
    priceSync: '/price-sync',
    stockSync: '/stock-sync',
    stocksHistory: '/stocks-history',
    ordersSync: '/orders-sync',
    exportDebug: '/export-debug',
    exportHistory: '/export-history',
    ordersDebug: '/orders-debug'
}

export function App() {
    useEffect(() => {
        ExportProductsApi.validate()
    }, [])
    return (
        <div className="App">
            <Notices/>
            <div className="flexbox wrap-mobile">

                <Menu/>

                <div className="content blank hide-scrollbar">
                    <div className={"article"}>
                        <div id="wa-app-content" className={"article-body"}>

                            <Switch>
                                <Route exact path={appPages.apiSettings}>
                                    <AuthPage/>
                                </Route>
                                <Route path={appPages.selectProducts}>
                                    <SelectProductsPage/>
                                </Route>
                                <Route path={appPages.categoriesComparison}>
                                    <CategoriesComparePage/>
                                </Route>
                                <Route path={appPages.generalOfferAttributes}>
                                    <GeneralOfferPage/>
                                </Route>
                                <Route path={appPages.offerAttributes} component={AttributesCategoryComparePage}/>
                                <Route path={appPages.priceSync}>
                                    <PriceUpdatePage/>
                                </Route>
                                <Route path={appPages.stockSync}>
                                    <StockUpdatePage/>
                                </Route>

                                <Route path={appPages.offersExport}>
                                    <ExportPage/>
                                </Route>
                                <Route path={appPages.exportHistory} component={ExportHistoryPage}/>
                                <Route path={appPages.ordersSync}>
                                    <OrdersSyncPage/>
                                </Route>
                                <Route path={appPages.exportDebug}>
                                    <ProductPage/>
                                </Route>
                                <Route path={appPages.ordersDebug}>
                                    <OrdersDebugPage/>
                                </Route>
                                <Route path={appPages.stocksHistory}>
                                    <StocksHistoryPage/>
                                </Route>
                            </Switch>
                        </div>

                    </div>

                </div>
            </div>


        </div>
    );
}

export default App;
